import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Bot, Users, Lightbulb, Award, Target, Zap, Linkedin } from 'lucide-react';
export function AboutPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-383">
      <Header data-id="element-384" />
      <main className="flex-grow" data-id="element-385">
        {/* Hero Section */}
        <div className="bg-black text-white py-16 md:py-24" data-id="element-386">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387">
            <div className="text-center" data-id="element-388">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-389">
                About Agentter.ai
              </h1>
              <p className="text-xl md:text-2xl max-w-3xl mx-auto text-gray-300" data-id="element-390">
                We're on a mission to make AI accessible and practical for
                businesses of all sizes.
              </p>
            </div>
          </div>
        </div>
        {/* Our Story */}
        <div className="py-16 md:py-24 bg-white" data-id="element-391">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-392">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-393">
              <div data-id="element-394">
                <h2 className="text-3xl font-bold mb-6" data-id="element-395">Our Story</h2>
                <p className="text-lg text-gray-600 mb-4" data-id="element-396">
                  Agentter.ai was founded in 2024 by a team of AI researchers
                  and business automation experts who saw a gap in the market:
                  powerful AI technology was available, but not accessible to
                  most businesses.
                </p>
                <p className="text-lg text-gray-600 mb-4" data-id="element-397">
                  We set out to build a platform that would allow any business,
                  regardless of technical expertise, to harness the power of AI
                  for their specific needs. Our no-code approach means that
                  anyone can create sophisticated AI agents by simply describing
                  what they need in plain English.
                </p>
                <p className="text-lg text-gray-600" data-id="element-398">
                  Today, Agentter.ai serves hundreds of businesses across
                  multiple industries, helping them automate workflows, improve
                  customer service, and operate more efficiently.
                </p>
              </div>
              <div className="relative" data-id="element-399">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Team collaboration" className="rounded-lg shadow-lg" data-id="element-400" />
                <div className="absolute -bottom-6 -right-6 bg-black p-4 rounded-lg" data-id="element-401">
                  <Bot className="text-white" size={32} data-id="element-402" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Our Values */}
        <div className="py-16 md:py-24 bg-gray-50" data-id="element-403">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-404">
            <div className="text-center mb-16" data-id="element-405">
              <h2 className="text-3xl font-bold mb-4" data-id="element-406">Our Values</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-407">
                These core principles guide everything we do at Agentter.ai.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-408">
              <ValueCard icon={<Lightbulb size={24} data-id="element-410" />} title="Innovation" description="We're constantly pushing the boundaries of what's possible with AI, developing new capabilities to solve real business problems." data-id="element-409" />
              <ValueCard icon={<Users size={24} data-id="element-412" />} title="Accessibility" description="We believe powerful technology should be accessible to everyone, not just those with technical expertise or large budgets." data-id="element-411" />
              <ValueCard icon={<Target size={24} data-id="element-414" />} title="Customer Focus" description="Everything we build starts with our customers' needs. We measure our success by the value we create for the businesses we serve." data-id="element-413" />
              <ValueCard icon={<Award size={24} data-id="element-416" />} title="Excellence" description="We hold ourselves to the highest standards in everything we do, from the technology we build to the service we provide." data-id="element-415" />
              <ValueCard icon={<Zap size={24} data-id="element-418" />} title="Empowerment" description="Our goal is to empower businesses to do more with less, freeing human potential for creative and strategic work." data-id="element-417" />
              <ValueCard icon={<Bot size={24} data-id="element-420" />} title="Ethical AI" description="We're committed to developing AI responsibly, with transparency and safeguards to ensure our technology is used for positive impact." data-id="element-419" />
            </div>
          </div>
        </div>
        {/* Leadership Team */}
        <div className="py-16 md:py-24 bg-white" data-id="element-421">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-422">
            <div className="text-center mb-16" data-id="element-423">
              <h2 className="text-3xl font-bold mb-4" data-id="element-424">Our Leadership Team</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-425">
                Meet the experts behind Agentter.ai's innovation and growth.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-426">
              <TeamMember image="https://uploadthingy.s3.us-west-1.amazonaws.com/nHmPSchT6Bc2bpBqhHdtrF/20ec474c-f476-4de2-905c-10332593b02a_%281%29.jpg" name="Ramzad Kumble" title="CEO & Founder" bio="15 years of experience in technology, development and product." linkedinUrl="https://www.linkedin.com/in/ramzadkumble/" data-id="element-427" />
              <TeamMember image="https://d225wy97wa5lhw.cloudfront.net/userData/1754043887307_IMG_1712.jpg" name="Mohammed Nabeel" title="CTO & Co-Founder" bio="Expert in technology, AI agent development." linkedinUrl="https://www.linkedin.com/in/nabilweq/" data-id="element-428" />
            </div>
          </div>
        </div>
        {/* Join Our Team */}
        <div className="py-16 md:py-24 bg-black text-white" data-id="element-429">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-430">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-431">
              <div data-id="element-432">
                <h2 className="text-3xl font-bold mb-6" data-id="element-433">Join Our Team</h2>
                <p className="text-xl text-gray-300 mb-6" data-id="element-434">
                  We're always looking for talented individuals who are
                  passionate about AI and want to make a difference.
                </p>
                <p className="text-xl text-gray-300 mb-8" data-id="element-435">
                  Check out our open positions and become part of our mission to
                  democratize AI for businesses everywhere.
                </p>
                <a href="#" className="bg-white text-black px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors inline-block" data-id="element-436">
                  View Open Positions
                </a>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-437">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Team collaboration" className="rounded-lg" data-id="element-438" />
                <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Office space" className="rounded-lg" data-id="element-439" />
                <img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Team meeting" className="rounded-lg" data-id="element-440" />
                <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Whiteboard session" className="rounded-lg" data-id="element-441" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-442" />
    </div>;
}
function ValueCard({
  icon,
  title,
  description
}) {
  return <div className="bg-white p-6 rounded-lg border border-gray-100 hover:shadow-md transition-shadow" data-id="element-443">
      <div className="bg-black text-white p-3 rounded-lg inline-block mb-4" data-id="element-444">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-2" data-id="element-445">{title}</h3>
      <p className="text-gray-600" data-id="element-446">{description}</p>
    </div>;
}
function TeamMember({
  image,
  name,
  title,
  bio,
  linkedinUrl
}) {
  return <div className="bg-white p-6 rounded-lg border border-gray-100 hover:shadow-md transition-shadow" data-id="element-447">
      <img src={image} alt={name} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover" data-id="element-448" />
      <h3 className="text-xl font-semibold text-center mb-1" data-id="element-449">{name}</h3>
      <p className="text-gray-500 text-center mb-2" data-id="element-450">{title}</p>
      <p className="text-gray-600 text-center mb-4" data-id="element-451">{bio}</p>
      {linkedinUrl && <div className="flex justify-center" data-id="element-452">
          <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-gray-700 hover:text-black transition-colors" data-id="element-453">
            <Linkedin size={18} className="mr-1" data-id="element-454" />
            <span data-id="element-455">LinkedIn Profile</span>
          </a>
        </div>}
    </div>;
}